export default __webpack_public_path__ + "static/media/min.61a2a589.mp3";